export const enum EAverageType {
  LINEAR = 'LINEAR',
  EXPONENTIAL = 'EXPONENTIAL'
}
